import { render, staticRenderFns } from "./truckageList.vue?vue&type=template&id=07d2885d"
import script from "./truckageList.vue?vue&type=script&lang=js"
export * from "./truckageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports